import React from 'react'
import {Box, Grow, Typography} from "@mui/material";

const Credit = () => {
  return (
    <Grow in>
    <Box bgcolor={"#D80032"} color={"white"} m={"3%"} p={"3%"} borderRadius={"5px"}>

<Typography variant='h4' textAlign={"center"}>Meet Kishore: The Mind Behind Eat Easy</Typography>
<p>Hey there, foodies!<b style={{margin:"3px"}}>I'm Kishore </b> , the proud developer and foodie mastermind behind Eat Easy, your one-stop shop for delicious deliveries in Madurai. My passion for good food and tech collided to create Eat Easy, and I'm thrilled to share it with you!</p>

<p>For me, food is more than just sustenance; it's an experience, a way to connect with people and cultures, and a source of pure joy. I believe everyone deserves access to amazing food, no matter how busy or indecisive they are. That's why I built Eat Easy – to make ordering delicious meals as easy as pie (or should I say, as easy as dosa?).</p>

<p>Building Eat Easy wasn't just about coding and algorithms; it was about understanding the Madurai food scene and the needs of its people. I wanted to create a platform that celebrated the incredible culinary diversity of our city, while making it accessible and convenient for everyone.</p>

<Typography variant='h4' textAlign={"center"}>Here's a peek into what drives me:</Typography>

<p><b>Tech-Savvy Chef</b>: I love the challenge of blending technology with the culinary world. Building user-friendly features, optimizing delivery routes, and ensuring a smooth ordering experience are all part of my culinary adventure.</p>
<p><b>Local Food Champion</b>: Madurai's street food scene is my playground! I'm constantly exploring new flavors, hidden gems, and the stories behind each dish. This passion translates into Eat Easy, featuring a curated selection of restaurants that showcase the best of our city's culinary talents.</p>
<p><b>Convenience Crusader</b>: Let's face it, who has time to spend hours browsing menus and calling restaurants? Eat Easy is all about making your life easier. From quick re-ordering to real-time tracking, I've poured my heart into building features that streamline your food journey.</p>
So, come join me on this delicious adventure! Download Eat Easy and explore the vibrant flavors of Madurai. Be it a comforting biryani from your favorite local joint or a taste of exotic Thai curry, Eat Easy brings your culinary dreams to life, one tap at a time.

And remember, I'm always working to improve Eat Easy and add new features that make your food ordering experience even better. So, feel free to drop me a line with your feedback or suggestions – I'm always happy to hear from fellow foodies!
<pre>
Bon appétit,<br /><br/>

Kishore <br /><br />

The Eat Easy Chef & Code Maestro
</pre>
    </Box>
    </Grow>
  )
}

export default Credit